import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3cb882ec"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["href"];
const _hoisted_2 = { class: "cardLabel" };
const _hoisted_3 = {
    key: 0,
    class: "description"
};
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "spacer" }, null, -1));
const _hoisted_5 = { class: "linkText" };
const _hoisted_6 = {
    key: 0,
    class: "fas fa-check-square ml-2"
};
const _hoisted_7 = {
    key: 1,
    class: "fas fa-external-link-alt ml-2"
};
const _hoisted_8 = { key: 1 };
const _hoisted_9 = { class: "linkText" };
const _hoisted_10 = {
    key: 0,
    class: "fas fa-lg fa-check-square ml-3"
};
const _hoisted_11 = {
    key: 1,
    class: "fas fa-lg fa-external-link-alt ml-3"
};
export default /*#__PURE__*/ _defineComponent({
    __name: 'InformationCardField',
    props: {
        card: {},
        viewed: { type: Boolean },
        size: {}
    },
    emits: ['viewed'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const openLink = () => {
            window.open(props.card.url);
            emit('viewed');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("a", {
                class: _normalizeClass(["wrapper", { small: _ctx.size == 'small', large: _ctx.size == 'large' }]),
                href: _ctx.card.url,
                style: _normalizeStyle(`background-color: ${_ctx.card.color ? _ctx.card.color : '#cccccc'}`),
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (openLink()), ["prevent"]))
            }, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.card.label), 1),
                (_ctx.card.description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.card.description), 1))
                    : _createCommentVNode("", true),
                _hoisted_4,
                _createElementVNode("div", {
                    class: _normalizeClass(["viewLink", { 'viewed': _ctx.viewed }])
                }, [
                    (_ctx.size == 'large')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: _normalizeStyle(`color: ${_ctx.card.color ? _ctx.card.color : '#cccccc'}`)
                        }, [
                            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.viewed ? 'Viewed!' : 'View Now'), 1),
                            (_ctx.viewed)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                                : (_openBlock(), _createElementBlock("i", _hoisted_7))
                        ], 4))
                        : _createCommentVNode("", true),
                    (_ctx.size == 'small')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.viewed ? 'Viewed!' : 'View Now'), 1),
                            (_ctx.viewed)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                                : (_openBlock(), _createElementBlock("i", _hoisted_11))
                        ]))
                        : _createCommentVNode("", true)
                ], 2)
            ], 14, _hoisted_1));
        };
    }
});
